import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-public-training-page',
  templateUrl: './public-training-page.component.html',
  styleUrls: ['./public-training-page.component.css']
})
export class PublicTrainingPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
